import type { SVGProps } from 'react';

export const BookmarkAdd = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.5 20.25V5.308c0-.505.175-.933.525-1.283.35-.35.778-.525 1.283-.525H13V5H7.308a.294.294 0 0 0-.212.096.294.294 0 0 0-.096.212V17.95l5-2.15 5 2.15V11h1.5v9.25L12 17.462 5.5 20.25ZM17 9V7h-2V5.5h2v-2h1.5v2h2V7h-2v2H17Z" />
    </svg>
  );
};
